<template>
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path
      fill-rule="evenodd"
      d="m4 19.4.5.2.5-.2q.5-.6 0-1.1a8 8 0 0 1-2.2-5.5q0-3.2 2.2-5.4.5-.5 0-1.1a1 1 0 0 0-1 0 9 9 0 0 0-2.7 6.5A9 9 0 0 0 4 19.4m3.5-1.8-.5-.2q-1.7-1.8-1.7-4.6T7 8.3q.5-.5 1 0t0 1a5 5 0 0 0-1.2 3.5A5 5 0 0 0 8 16.3q.5.6 0 1-.2.3-.5.3m4.5-2a2.7 2.7 0 1 1 0-5.5 2.7 2.7 0 0 1 0 5.5m4.5 2a.7.7 0 0 1-.8-.8q0-.3.3-.5a5 5 0 0 0 1.2-3.5A5 5 0 0 0 16 9.4a1 1 0 0 1 0-1.1q.5-.5 1 0 1.7 1.7 1.7 4.5T17 17.4zm2.5 1.8.5.2.5-.2a9 9 0 0 0 2.7-6.6A9 9 0 0 0 20 6.3a1 1 0 0 0-1 0q-.5.6 0 1a8 8 0 0 1 2.2 5.5q0 3.2-2.2 5.5-.5.6 0 1"
      clip-rule="evenodd"
    />
  </svg>
</template>
